<template>
  <filter-wrapper @submit="submit">
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('mailer.sender.modal.add.sender_name') }}
        </label>
        <div class="filter__item__body">
          <i-input v-model="form.name" :clearable="true" />
        </div>
      </div>

      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('mailer.stats.detailed.filter.status.title') }}
        </label>
        <div class="filter__item__body">
          <senders-input-status v-model="form.status" />
        </div>
      </div>

      <div class="filter__item filter__item--button">
        <i-button html-type="submit" type="primary">
          {{ $t('shared.component.filter.show_result') }}
        </i-button>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import SendersInputStatus from './senders-input-status';
  import FilterWrapper from '@shared/components/filter-base';
  import { mapActions } from 'vuex';

  export default {
    components: {
      FilterWrapper,
      SendersInputStatus
    },
    data: () => ({
      form: {
        name: null,
        status: null
      }
    }),

    created() {
      this.submit();
    },

    methods: {
      ...mapActions('mailer/senders/table', ['search']),
      submit: function () {
        const { name, status } = this.form;

        const params = {
          name,
          status: status !== 'all' ? status : null
        };

        this.search(params);
      }
    }
  };
</script>